export const environment = {
  production: true,
  LocationsApiBaseUrl: '/api/locations',
  OrchestratorApiBaseUrl: '/api/orchestrator',
  googleMapsApiKey: 'AIzaSyAJZdW9wANQy6RwHpbTFsXZPX78pd1O9cY',
  loggingApiUrl: '/api/logging',
  disableLogging: false,
  keycloak: {
    url: 'https://keycloak.filterlabs.ai',
    realm: 'filter-labs-web',
    clientId: 'web-app'
  }
};